// EmailJS Configuration
// 
// 
// Get your credentials from: https://dashboard.emailjs.com/
// 
// Steps to get your keys:
// 1. Sign up at https://www.emailjs.com/
// 2. Go to Email Services → Add New Service → Select Gmail/Outlook/etc
// 3. Go to Email Templates → Create New Template
// 4. Go to Account → Copy your Public Key
// 
// Template Variables to use in EmailJS template:
// {{from_name}} - Full name
// {{company_name}} - Company name
// {{from_email}} - Email address
// {{phone}} - Phone/WhatsApp number
// {{product_interested}} - Product interested in
// {{message}} - Message content

export const EMAILJS_CONFIG = {
  SERVICE_ID: "service_zjj75yr",      // Replace with your EmailJS Service ID
  TEMPLATE_ID: "template_9t9c6qi",    // Replace with your EmailJS Template ID
  PUBLIC_KEY: "FF7dDsZuavCaTuNWF"       // Replace with your EmailJS Public Key
};
